import React, { useState } from 'react';

const normalizar = (t) => (t ?? '').toString().toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '');

// Lista desplegable. Con `buscable` (celular) se puede escribir para filtrar las opciones;
// sin `buscable` es un <select> normal. `onChange` recibe un objeto con { target: { value } },
// igual que un <select>, para poder reemplazar uno por otro sin cambiar los manejadores.
export default function SelectorBuscable({ value, onChange, opciones, placeholder, disabled, style, buscable }) {
  const [abierto, setAbierto] = useState(false);
  const [texto, setTexto] = useState('');

  if (!buscable) {
    return (
      <select value={value} onChange={onChange} disabled={disabled} style={style}>
        <option value=''>{placeholder}</option>
        {opciones.map(o => <option key={o.value} value={o.value}>{o.label}</option>)}
      </select>
    );
  }

  const seleccionada = opciones.find(o => o.value === value);
  const filtradas = opciones.filter(o => !texto.trim() || normalizar(o.label).includes(normalizar(texto)));

  const elegir = (v) => {
    onChange({ target: { value: v } });
    setAbierto(false);
    setTexto('');
  };

  return (
    <div style={{ position: 'relative' }}>
      <input
        value={abierto ? texto : (seleccionada ? seleccionada.label : '')}
        placeholder={placeholder}
        disabled={disabled}
        autoComplete='off'
        onFocus={() => { setAbierto(true); setTexto(''); }}
        onBlur={() => setAbierto(false)}
        onChange={e => setTexto(e.target.value)}
        onKeyDown={e => { if (e.key === 'Enter' && filtradas.length > 0) { e.preventDefault(); elegir(filtradas[0].value); } }}
        style={{ ...style, width: '100%', boxSizing: 'border-box' }}
      />
      {abierto && (
        <div style={{ position: 'absolute', top: '100%', left: 0, right: 0, zIndex: 60, background: '#fff', border: '0.5px solid #ddd', borderRadius: '8px', boxShadow: '0 4px 12px rgba(0,0,0,0.15)', maxHeight: '240px', overflowY: 'auto', marginTop: '2px' }}>
          {value && (
            <div onPointerDown={e => { e.preventDefault(); elegir(''); }}
              style={{ padding: '12px 14px', fontSize: '13px', color: '#888', borderBottom: '0.5px solid #f0f0f0' }}>
              Quitar selección
            </div>
          )}
          {filtradas.length === 0 ? (
            <div style={{ padding: '12px 14px', fontSize: '13px', color: '#aaa' }}>Sin resultados</div>
          ) : filtradas.map(o => (
            <div key={o.value} onPointerDown={e => { e.preventDefault(); elegir(o.value); }}
              style={{ padding: '12px 14px', fontSize: '14px', color: '#333', borderBottom: '0.5px solid #f5f5f5', background: o.value === value ? '#f5f5f5' : '#fff' }}>
              {o.label}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
